import React, { useState } from 'react';
import {
  FaConciergeBell,
  FaCopy,
  FaKey,
  FaMobileAlt,
  FaQrcode,
} from 'react-icons/fa';
import { CustomToggle } from '../../../components/CustomToggle';
import { InfoDescription } from '../../../components/InfoDescription';
import { CustomButton } from '../../../components/CustomButton';
import RModal from '../../../components/Rsuite/Modal';
import { useAuth } from '../../../hooks/auth';
import api from '../../../services/api';
import { toastSuccess, toastError } from '../../../toasts';
import {
  ContainerLoja,
  ContentLoja,
  SettingsCard,
  CardHeader,
  ToggleRow,
  QrCodeRow,
  QrCodeActions,
  ApiKeyBox,
} from './styles';

const DigitalMenu = ({ config, change }) => {
  const { id_empresa } = useAuth();
  const [tipoModulo, setTipoModulo] = useState('MESA');
  const [numerosModulo, setNumerosModulo] = useState(1);
  const [loadingQr, setLoadingQr] = useState(false);
  const [loadingApiKey, setLoadingApiKey] = useState(false);
  const [confirmApiKeyOpen, setConfirmApiKeyOpen] = useState(false);
  const [generatedApiKey, setGeneratedApiKey] = useState(null);

  const gerarQrCodes = async () => {
    try {
      setLoadingQr(true);
      const response = await api.post('sessoes/gerar-qr-code', {
        tipoModulo,
        numerosModulo: Number(numerosModulo),
        contrato: Number(id_empresa),
      });
      toastSuccess('QR Codes gerados com sucesso');
      window.open(response.data.url, '_blank');
    } catch {
      toastError('Não foi possível gerar os QR Codes');
    } finally {
      setLoadingQr(false);
    }
  };

  const gerarApiKey = async () => {
    try {
      setLoadingApiKey(true);
      const response = await api.post('sessoes/gerar-api-key', {
        nrContrato: Number(id_empresa),
      });
      setConfirmApiKeyOpen(false);
      setGeneratedApiKey(response.data.cardapioApiKey);
      toastSuccess('Chave gerada com sucesso');
    } catch {
      toastError('Não foi possível gerar a chave');
    } finally {
      setLoadingApiKey(false);
    }
  };

  const copiarApiKey = async () => {
    try {
      await navigator.clipboard.writeText(generatedApiKey);
      toastSuccess('Chave copiada para a área de transferência');
    } catch {
      toastError('Não foi possível copiar. Selecione e copie manualmente.');
    }
  };
  return (
    <ContainerLoja>
      <ContentLoja>
        <SettingsCard>
          <CardHeader>
            <FaConciergeBell />
            <h3>Operação do Cardápio</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Modo Catálogo"
              description="Desativa o carrinho. O cliente apenas vê os produtos, sem poder comprar."
            />
            <CustomToggle
              id="visualizacaoCardapio"
              checked={!!config.cardapioVisualizacao}
              onChange={() =>
                change(
                  'cardapioVisualizacao',
                  Number(!config.cardapioVisualizacao),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Compras sem Autenticação"
              description="Permite que o garçom ou gestor não precise autenticar o cliente para realizar vendas."
            />
            <CustomToggle
              id="vendaSemAutenticacao"
              checked={!!config.vendaSemAutenticacao}
              onChange={() =>
                change(
                  'vendaSemAutenticacao',
                  Number(!config.vendaSemAutenticacao),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Identificação do Cliente"
              description="Permite que o cliente se identifique na mesa ou cartão para facilitar o atendimento e controle de pedidos."
            />
            <CustomToggle
              id="identificationCustomer"
              checked={!!config.identificationCustomer}
              onChange={() =>
                change(
                  'identificationCustomer',
                  Number(!config.identificationCustomer),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Bloquear Cartão de Consumo"
              description="Impede novos pedidos se a comanda/cartão do cliente não for 'Livre'."
            />
            <CustomToggle
              id="vendaBloqueadaCartaoLivre"
              checked={!!config.vendaBloqueadaCartaoLivre}
              onChange={() =>
                change(
                  'vendaBloqueadaCartaoLivre',
                  Number(!config.vendaBloqueadaCartaoLivre),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Exigir Local de Entrega"
              description="Obriga o cliente a informar onde está (ex: Número da Mesa) ao pedir."
            />
            <CustomToggle
              id="localEntrega"
              checked={!!config.localEntrega}
              onChange={() =>
                change('localEntrega', Number(!config.localEntrega))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Encerrar Sessão Após Pedido"
              description="Encerra a sessão do cliente automaticamente após um pedido ser realizado."
            />
            <CustomToggle
              id="endSessionAfterOrder"
              checked={!!config.endSessionAfterOrder}
              onChange={() =>
                change(
                  'endSessionAfterOrder',
                  Number(!config.endSessionAfterOrder),
                )
              }
            />
          </ToggleRow>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaMobileAlt />
            <h3>Interface e Exibição</h3>
          </CardHeader>
          <ToggleRow>
            <InfoDescription
              label="Botão 'Chamar Garçom'"
              description="Exibe um atalho rápido na tela para o cliente solicitar atendimento na mesa."
            />
            <CustomToggle
              id="verChamaGarcom"
              checked={!!config.verChamaGarcom}
              onChange={() =>
                change('verChamaGarcom', Number(!config.verChamaGarcom))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Botão 'Solicitar Conta'"
              description="Exibe um atalho rápido na tela para o cliente solicitar a conta da mesa ou cartão."
            />
            <CustomToggle
              id="enableRequestBill"
              checked={!!config.enableRequestBill}
              onChange={() =>
                change('enableRequestBill', Number(!config.enableRequestBill))
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Categorias na Tela Inicial"
              description="Destaca os grupos de produtos logo ao abrir o cardápio."
            />
            <CustomToggle
              id="mostrarCategoriasInicio"
              checked={!!config.mostrarCategoriasInicio}
              onChange={() =>
                change(
                  'mostrarCategoriasInicio',
                  Number(!config.mostrarCategoriasInicio),
                )
              }
            />
          </ToggleRow>
          <ToggleRow>
            <InfoDescription
              label="Promoções na Tela Inicial"
              description="Exibe os banners de ofertas logo na primeira tela do app."
            />
            <CustomToggle
              id="mostrarPromocoesInicio"
              checked={!!config.mostrarPromocoesInicio}
              onChange={() =>
                change(
                  'mostrarPromocoesInicio',
                  Number(!config.mostrarPromocoesInicio),
                )
              }
            />
          </ToggleRow>
          
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaQrcode />
            <h3>QRCodes</h3>
          </CardHeader>
          <InfoDescription
            label="Gerar QR Codes"
            description="Gere os QR Codes para suas mesas ou cartões de consumo e baixe em formato ZIP."
          />
          <QrCodeRow>
            <label>Tipo de Módulo</label>
            <select
              value={tipoModulo}
              onChange={(e) => setTipoModulo(e.target.value)}
            >
              <option value="MESA">Mesa</option>
              <option value="CARTÃO">Cartão</option>
            </select>
          </QrCodeRow>
          <QrCodeRow>
            <label>Quantidade</label>
            <input
              type="number"
              min={1}
              value={numerosModulo}
              onChange={(e) => setNumerosModulo(e.target.value)}
            />
          </QrCodeRow>
          <QrCodeActions>
            <CustomButton
              appearance="primary"
              onClick={gerarQrCodes}
              loading={loadingQr}
              disabled={!numerosModulo || numerosModulo < 1}
            >
              <FaQrcode style={{ marginRight: 6 }} />
              Gerar e Baixar ZIP
            </CustomButton>
          </QrCodeActions>
        </SettingsCard>
        <SettingsCard>
          <CardHeader>
            <FaKey />
            <h3>Autenticação da API Local</h3>
          </CardHeader>
          <InfoDescription
            label="Chave de segurança do servidor local"
            description="Gera uma chave exclusiva para autenticar o servidor local (API Local) deste contrato junto ao MenuCheff, evitando que outra instância indevida se conecte no lugar dela."
          />
          <QrCodeActions>
            <CustomButton
              appearance="primary"
              onClick={() => setConfirmApiKeyOpen(true)}
              loading={loadingApiKey}
            >
              <FaKey style={{ marginRight: 6 }} />
              Gerar Nova Chave
            </CustomButton>
          </QrCodeActions>
        </SettingsCard>
      </ContentLoja>

      <RModal
        open={confirmApiKeyOpen}
        onClose={() => setConfirmApiKeyOpen(false)}
        title="Gerar nova chave da API Local?"
        bodyWidth={420}
        footer={
          <>
            <CustomButton
              appearance="subtle"
              onClick={() => setConfirmApiKeyOpen(false)}
            >
              Cancelar
            </CustomButton>
            <CustomButton
              appearance="primary"
              loading={loadingApiKey}
              onClick={gerarApiKey}
            >
              Confirmar e Gerar
            </CustomButton>
          </>
        }
      >
        <p>
          Isso substitui a chave atual deste contrato, caso exista uma. O
          servidor local que já estiver configurado com a chave anterior
          deixa de se conectar até você atualizar o arquivo{' '}
          <code>contract-secret.txt</code> dele com o novo valor.
        </p>
      </RModal>

      <RModal
        open={!!generatedApiKey}
        onClose={() => setGeneratedApiKey(null)}
        title="Nova chave gerada"
        bodyWidth={420}
        footer={
          <CustomButton
            appearance="primary"
            onClick={() => setGeneratedApiKey(null)}
          >
            Fechar
          </CustomButton>
        }
      >
        <p>
          Copie este valor agora — ele não será exibido novamente. Salve-o no
          arquivo <code>contract-secret.txt</code> do servidor local
          autorizado deste contrato.
        </p>
        <ApiKeyBox>
          <code>{generatedApiKey}</code>
          <CustomButton appearance="ghost" onClick={copiarApiKey}>
            <FaCopy style={{ marginRight: 6 }} />
            Copiar
          </CustomButton>
        </ApiKeyBox>
      </RModal>
    </ContainerLoja>
  );
};

export default DigitalMenu;
